'use strict';

/* jshint -W098 */
angular.module('mean.contacts').controller('ContactsController', ['$scope', 'Global', 'Contacts', 'MeanUser', 'userService', 'ngDialog', 'Requests', 'toaster', 'Builders', 'Trades', '$q', '$filter', 'builderService', '$rootScope',
  function($scope, Global, Contacts, MeanUser, userService, ngDialog, Requests, toaster, Builders, Trades, $q, $filter, builderService, $rootScope) {
    $scope.global = Global;
    $scope.package = {
      name: 'contacts'
    };

    $scope.user = MeanUser.user;
    $scope.selectedDivision = {};

    $scope.menu = ['Business', 'Personal'];
    $scope.current_menu = 'Business';

    $scope.builder_contacts = [];
    $scope.trade_contacts = [];
    $scope.requests = [];
    $scope.my_requests = [];

    $scope.is_admin = userService.isAdmin($scope.user);

    $scope.is_builder = builderService.isBuilder($scope.user.username);

    //first check to see if i have any requests waiting
    $scope.init = function() {
        Requests.query({'requestee': $scope.user._id}, function(requests) {
            $scope.requests = requests;
        });

        Requests.query({'requestor': $scope.user._id}, function(requests) {
            $scope.my_requests = requests;
        });

        $scope.updateContacts();
    };

    $rootScope.$on('update-contact-list', function handler() {
        $scope.builder_contacts = [];
        $scope.trade_contacts = [];
        $scope.updateContacts();
    });

    $scope.updateContacts = function() {
        //now lets see if i have any contacts
        Contacts.query({'user': $scope.user._id}, function(contacts) {
            if(contacts.length === 1) {
                $scope.contacts = contacts[0];

                // $scope.trade_contacts = $scope.contacts.trades;
                // $scope.trade_contacts.trade = $scope.contacts.trades.trade[0];

                $scope.contacts.trades.forEach(function(trade) {
                    Trades.query({'main_account_id': trade._id}, function(item) {
                        if(item.length === 1) {
                            var inlist = $filter('filter')($scope.trade_contacts, {'_id': item[0]._id}, true);

                            if(inlist.length == 0) {
                                $scope.trade_contacts.push({
                                    _id: item[0]._id,
                                    name: item[0].name,
                                    address: item[0].address_one,
                                    city: item[0].city,
                                    state: item[0].state,
                                    zip: item[0].zip,
                                    email: item[0].email,
                                    phone: item[0].phone,
                                    trade: trade.trade[0]
                                });
                            }
                        }
                    });
                });
            } else if(contacts.length === 0) {
                var contacts = new Contacts({
                    user: $scope.user._id
                });

                contacts.$save(function(results) {
                    $scope.contacts = results;
                    toaster.pop('success', 'Contacts', 'New database created');
                }, function(error) {
                    toaster.pop('error', 'Contacts', error);
                });
            }
        });

        //now i need to get the business contacts that
        //i'm associated with based on my main account
        userService.getMainAccountId($scope.user.username).then(function(main_id) {
            Contacts.query({'user': main_id}, function(contacts) {
                if(contacts.length === 1) {
                    if($scope.is_builder) {
                        contacts[0].trades.forEach(function(trade) {
                            Trades.query({'main_account_id': trade._id}, function(item) {
                                if(item.length === 1) {
                                    var inlist = $filter('filter')($scope.trade_contacts, {'_id': item[0]._id}, true);

                                    if(inlist.length == 0) {
                                        $scope.trade_contacts.push({
                                            _id: item[0]._id,
                                            name: item[0].name,
                                            address: item[0].address_one,
                                            city: item[0].city,
                                            state: item[0].state,
                                            zip: item[0].zip,
                                            email: item[0].email,
                                            phone: item[0].phone,
                                            trade: trade.trade[0]
                                        });
                                    }
                                }
                            });
                        });
                    } else {
                        contacts[0].builders.forEach(function(builder) {
                            Builders.query({'builder': builder._id}, function(found) {
                                if(found.length === 1) {
                                    $scope.builder_contacts.push({
                                        name: found[0].name,
                                        address: found[0].address_one,
                                        city: found[0].city,
                                        state: found[0].state,
                                        zip: found[0].zip,
                                        email: found[0].email,
                                        phone: found[0].phone
                                    });
                                }
                            });
                        });
                    }
                } 
            });
        });
    };

    $scope.onSelect = function(item) {
        $scope.current_menu = item
    };

    //this will build a personal request
    $scope.addFromCompany = function() {
        ngDialog.open({
            template: 'contacts/views/company-user-list.html',
            className: 'ngdialog-theme-default',
            scope: $scope,
            controller: 'CompanyContactController'
        });
    };

    //this is part of the business request process
    $scope.addBusiness = function() {
        if(!$scope.is_admin) {
            toaster.pop('error', 'Contacts', 'Must be an admin to perform this operation');
            return;
        }

        ngDialog.open({
            template: 'contacts/views/business-list.html',
            className: 'ngdialog-theme-default',
            scope: $scope,
            controller: 'BusinessContactController'
        });
    };

    //this will update the database entry for contacts
    //and it will remove the request.  Add everything
    //to the personal list.  User can move to business later
    $scope.acceptRequest = function(item) {
        //$scope.contacts = this.$parent.contacts;
        if(!$scope.contacts) {
            toaster.pop('error', 'Contacts', 'Problem with the user database. Contact Admin');
            return;
        }

        if(item.type === 'Personal') {
            $scope.contacts.personal.push(item.requestor._id);
        } else {
            if($scope.is_builder)
              $scope.contacts.trades.push(item.requestor._id);
            else {
                $scope.contacts.builders.push(item.requestor._id);
            }
        }

        $scope.contacts.$update(function(results) {
            //we saved the contact, now it's time to update the requestee
            Contacts.query({'user': item.requestor._id}, function(contacts) {
                if(contacts.length === 1) {
                    if(item.type === 'Personal') {
                        contacts[0].personal.push(item.requestee._id);
                    } else {
                        if($scope.is_builder) {
                            contacts[0].builders.push(item.requestee._id);
                        } else {
                            contacts[0].trades.push(item.requestee._id);
                        }
                    }
                    contacts[0].$update();
                }
                var index = $scope.requests.indexOf(item);
                $scope.requests.splice(index, 1);
                item.$delete(function(success) {
                    $scope.builder_contacts = [];
                    $scope.trade_contacts = [];
                    $scope.updateContacts();
                    toaster.pop('success', 'Contacts', 'New contact added');
                }, function(error) {
                    toaster.pop('error', 'Contacts Error', error);
                });
            });
        }, function(error) {
            toaster.pop('error', 'Contacts', error);
        });
    };

    //this will just remove the request
    $scope.declineRequest = function(item) {
        item.$delete(function(result) {
            var index = $scope.requests.indexOf(result);
            $scope.requests.splice(index, 1);
            $scope.builder_contacts = [];
            $scope.trade_contacts = [];
            $scope.updateContacts();
            toaster.pop('success', 'Contacts', 'Contact Request Removed');
        }, function(error) {
            toaster.pop('error', 'Contacts', error);
        });
    };
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/contacts/public/controllers/contacts.js